import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const Insurance = ({ insurances }) => (
  <>
    <h5>Patient Insurance</h5>
    <Table
      borderless
      border="0"
      cellSpacing="0"
      cellPadding="0"
      className="insurance-table"
    >
      <thead>
        <tr>
          <th>
            <div className="pagination-container">
              <h5>Provider</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Number</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Type</h5>
            </div>
          </th>
          <th>
            <div className="pagination-container">
              <h5>Plan Name</h5>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {insurances.map((insurance, index) => (
          <tr key={index}>
            <td>{insurance.provider}</td>
            <td>{insurance.number}</td>
            <td>{insurance.type}</td>
            <td>{insurance.planName}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
);

Insurance.propTypes = {
  insurances: PropTypes.array.isRequired,
};

export default Insurance;
